export const appConfig = {
  appTitle: "بونیبو ادمین - Bonibo Admin",

  baseUrl: process.env.REACT_APP_BASE_URL!,
  apiUrl: process.env.REACT_APP_API_URL!,
  identityUrl: process.env.REACT_APP_IDENTITY_URL!,
  accountingUrl: process.env.REACT_APP_ACCOUNTING_URL!,
  boardUrl: process.env.REACT_APP_BOARD_URL!,
  articlesUrl: process.env.REACT_APP_ARTICLES_URL!,

  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY!,

  applicationPaths: {
    defaultLoginRedirectPath: "/",
    login: `/login`,
    register: `/register`,
    profile: `/profile`,
  },

  authEndpoints: [
    "/api/identity/login",
    "/api/identity/logout",
    "/api/identity/refresh-token",
    "/api/identity/register",
    "/api/identity/verify",
    "/api/identity/send-verify-token",
    "/api/identity/send-recovery-token",
    "/api/identity/reset-password",
  ],

  refreshUrl: `${process.env.REACT_APP_IDENTITY_URL!}/api/identity/refresh-token`,
};
